import * as React from 'react'
import {InputAdornment, TextField} from '@mui/material'
import { textFieldStyle } from '../Graphics'
import { parseDistText, sanitizeLengthString } from '../utility'

type Props = {
  propertyName: string
  inputPrefix: string
  valueObject: any
  onBlur: Function
  show?: boolean
  disabled?: boolean
}

export default function UILengthTextField({propertyName, inputPrefix, valueObject, onBlur, show=true, disabled=false}: Props){
  const initTxt = `${valueObject[propertyName]}"`
  const [txt, setTxt] = React.useState(initTxt)

  const handleChangeLength = (event: React.ChangeEvent<HTMLInputElement> ) => {
    const value: string = (event.target as HTMLInputElement).value
    setTxt(sanitizeLengthString(value))
  }

  const handleBlurLength = (event: React.FocusEvent<HTMLInputElement>) => {
    const propertyName: string = (event.target as HTMLInputElement).name
    const value: string = (event.target as HTMLInputElement).value
    const distance = parseDistText(value)
    if(distance && !Number.isNaN(distance.value) && Number.isFinite(distance.value)){
      setTxt(distance.toInchString(4))
      onBlur(propertyName, distance)
    }
    else{
      alert('Text entered is not a valid length.')
      setTxt(initTxt)
    }
  }

  return(
    <>
      {show ?
        <TextField
          key={initTxt + propertyName + 'edit'}
          disabled={disabled}
          name={propertyName}
          value={txt}
          type='text'
          style={textFieldStyle}
          InputProps={{
            startAdornment: <InputAdornment position='start'>{inputPrefix}</InputAdornment>,
            style: textFieldStyle
          }}
          onChange={handleChangeLength}
          onBlur={handleBlurLength}
        />
      :<></>
      }
    </>
  )
}